import update from 'immutability-helper';
import _ from 'lodash';
import { Action } from '../../redux.types';
import { PERMISSIONS_ACTION_NAMES } from '../permissions.actions';
import { PermissionsListState, RawPermission } from '../permissions.types';

const defaultState: PermissionsListState = {
  itemsMap: {},
  ids: [],
};

export const permissionsList = (
  state: PermissionsListState = defaultState,
  { type, payload }: Action,
): PermissionsListState => {
  switch (type) {
    case PERMISSIONS_ACTION_NAMES.LOAD_PERMISSIONS_SUCCESS: {
      const itemsMap = _(payload.responsePayload)
        .map((permission: RawPermission) => {
          return {
            ..._.pick(permission, ['active', 'id', 'name', 'projectId']),
            hint: permission.activeRevision.hint,
          };
        })
        .keyBy('id')
        .value();

      return {
        ...state,
        itemsMap,
        ids: _.keys(itemsMap),
      };
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_PERMISSION_SUCCESS: {
      const permissionRaw = payload.responsePayload;
      const permission = {
        ..._.pick(permissionRaw, ['active', 'id', 'name', 'projectId']),
        hint: permissionRaw.activeRevision.hint,
      };

      return {
        itemsMap: update(state.itemsMap, {
          $merge: { [permission.id]: permission },
        }),
        ids: update<string[]>(state.ids, { $push: [permission.id] }),
      };
    }

    case PERMISSIONS_ACTION_NAMES.DELETE_PERMISSION_SUCCESS: {
      const { permissionId } = payload.additionalData;
      const ids = _.pull(state.ids, permissionId);

      return {
        ...state,
        itemsMap: _.omit(state.itemsMap, permissionId),
        ids,
      };
    }

    case PERMISSIONS_ACTION_NAMES.UPDATE_PERMISSION_SUCCESS: {
      const permissionRaw = payload.responsePayload;

      return {
        ...state,
        itemsMap: update(state.itemsMap, {
          $merge: {
            [permissionRaw.id]: {
              ...state.itemsMap[permissionRaw.id],
              name: permissionRaw.name,
            },
          },
        }),
      };
    }

    case PERMISSIONS_ACTION_NAMES.ACTIVATE_PERMISSION_SUCCESS: {
      const { permissionId } = payload.additionalData;

      return {
        ...state,
        itemsMap: update(state.itemsMap, {
          [permissionId]: {
            $merge: {
              active: true,
            },
          },
        }),
      };
    }

    case PERMISSIONS_ACTION_NAMES.DEACTIVATE_PERMISSION_SUCCESS: {
      const { permissionId } = payload.additionalData;

      return {
        ...state,
        itemsMap: update(state.itemsMap, {
          [permissionId]: {
            $merge: {
              active: false,
            },
          },
        }),
      };
    }

    default: {
      return state;
    }
  }
};
